import { useQuery } from '@tanstack/react-query';
import { api, GameStateAuditEntry } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseAdminAuditLogOptions {
  userId?: string;
  keyword?: string;
  limit?: number;
  offset?: number;
}

interface UseAdminAuditLogReturn {
  entries: GameStateAuditEntry[];
  total: number;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useAdminAuditLog(options?: UseAdminAuditLogOptions): UseAdminAuditLogReturn {
  const userId = options?.userId;
  const keyword = options?.keyword;
  const limit = options?.limit;
  const offset = options?.offset;

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: queryKeys.gameState.adminAuditLog({ userId, keyword, limit, offset }),
    queryFn: () => api.adminListGameStateAuditLog({ userId, keyword, limit, offset }),
  });

  return {
    entries: data?.entries ?? [],
    total: data?.total ?? 0,
    loading: isLoading,
    error: error instanceof Error ? error.message : error ? 'Failed to load audit log' : null,
    refresh: () => {
      refetch();
    },
  };
}
